import { Action } from 'redux'
import { ThunkAction } from "redux-thunk";
import { AppState } from '../store'
import { APP_CHANGE_LOADING_SCREEN_TEXT } from '../store/actions/application-actions'
import { apphistory } from '../store';
import { AppLinks } from '../environment/app-links'

export const invokeLoadingWithText = (loadingText: string, urlPath?: string ): ThunkAction<void, AppState, unknown, Action<any>> => async (dispatch) => {
   await dispatch({
      type: APP_CHANGE_LOADING_SCREEN_TEXT,
      payload: loadingText
   })

   if(urlPath){
      apphistory.push(urlPath)
   }
   else {
      apphistory.push(AppLinks.waiting)
   }

}